"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceTypeToJSON = exports.ResourceTypeFromJSONTyped = exports.ResourceTypeFromJSON = exports.ResourceType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var ResourceType;
(function (ResourceType) {
    ResourceType["Account"] = "account";
    ResourceType["Organization"] = "organization";
    ResourceType["File"] = "file";
    ResourceType["Folder"] = "folder";
    ResourceType["Client"] = "client";
    ResourceType["Appointment"] = "appointment";
    ResourceType["Scheduler"] = "scheduler";
    ResourceType["Availability"] = "availability";
    ResourceType["Invoice"] = "invoice";
    ResourceType["Product"] = "product";
    ResourceType["Package"] = "package";
    ResourceType["Message"] = "message";
    ResourceType["Smartaction"] = "smartaction";
    ResourceType["Note"] = "note";
    ResourceType["Form"] = "form";
    ResourceType["BillingRate"] = "billing-rate";
    ResourceType["SessionBilling"] = "session-billing";
    ResourceType["Workflow"] = "workflow";
    ResourceType["Subscription"] = "subscription";
})(ResourceType || (exports.ResourceType = ResourceType = {}));
function ResourceTypeFromJSON(json) {
    return ResourceTypeFromJSONTyped(json, false);
}
exports.ResourceTypeFromJSON = ResourceTypeFromJSON;
function ResourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ResourceTypeFromJSONTyped = ResourceTypeFromJSONTyped;
function ResourceTypeToJSON(value) {
    return value;
}
exports.ResourceTypeToJSON = ResourceTypeToJSON;
//# sourceMappingURL=ResourceType.js.map